//api 接口处理
import request from '@/utils/request.js'
export default {
    //线索列表
    clueList(param) {
        return request.post(
            'merchant/Customer.clue/clueList',
            param,
            false,
            true
        )
    },
    //线索来源
    clueOrigin(param) {
        return request.post(
            'merchant/Customer.clue/clueOrigin',
            param,
            false,
            true
        )
    },
    //客户列表
    customerList(param) {
        return request.post(
            'merchant/Customer.client/customerList',
            param,
            false,
            true
        )
    },
    //客户详情-基础信息
    customerInfo(param) {
        return request.post(
            'merchant/Customer.client/customerInfo',
            param,
            false,
            true
        )
    },
    //客户详情-标签
    customerLabel(param) {
        return request.post(
            'merchant/Customer.client/customerLabel',
            param,
            false,
            true
        )
    },
    //客户详情-领取记录
    receiveRecord(param) {
        return request.post(
            'merchant/Customer.client/receiveRecord',
            param,
            false,
            true
        )
    },
    //客户详情-动态-基础信息修改记录
    customerInfoRecord(param) {
        return request.post(
            'merchant/Customer.client/customerInfoRecord',
            param,
            false,
            true
        )
    },
    //客户详情-动态-待办事项
    planRecord(param) {
        return request.post(
            'merchant/Customer.client/planRecord',
            param,
            false,
            true
        )
    },
    //客户详情-动态-报备记录
    reportRecord(param) {
        return request.post(
            'merchant/Customer.client/reportRecord',
            param,
            false,
            true
        )
    },
    //客户详情-动态-跟踪记录
    trackRecord(param) {
        return request.post(
            'merchant/Customer.client/trackRecord',
            param,
            false,
            true
        )
    },
    //线索分配
    clueDistributions(param) {
        return request.post(
            'merchant/Operation.customer/clueDistributions',
            param,
            false,
            true
        )
    },
    //转接客户到同事
    transfer(param) {
        return request.post(
            'merchant/Operation.customer/transfer',
            param,
            false,
            true
        )
    },
    //企业客户
    workCustomer(param) {
        return request.post(
            'merchant/Customer.client/workCustomer',
            param,
            false,
            true
        )
    },
    //线索删除
    clueDel(param) {
        return request.post(
            'merchant/Customer.clue/clueDel',
            param,
            false,
            true
        )
    },
    //设置线索可见
    clueVisible(param) {
        return request.post(
            '/merchant/Customer.clue/clueVisible',
            param,
            false,
            true
        )
    },
    //设置客户可见
    clientVisible(param) {
        return request.post(
            '/merchant/Customer.client/clientVisible',
            param,
            false,
            true
        )
    },
}
